import React, { useState } from 'react';
import { useStripe, useElements } from '@stripe/react-stripe-js';
import { useUser } from '../../providers/UserContext';
import axios from 'axios';

const Payment = () => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [paymentSuccess, setPaymentSuccess] = useState(false);

  const { user } = useUser();

  const apiUrl = process.env.REACT_APP_API_URL;
  const stripePrice = process.env.REACT_APP_STRIPE_PRICE;

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setErrorMessage('');

    if (!stripe || !elements) {
      setLoading(false);
      return;
    }

    // Paso 1: Llama a tu backend para crear una sesión de pago en Stripe
    try {
      var userUID = user.uid ? user.uid : localStorage.getItem("userUID")
      const { data } = await axios.post(`${apiUrl}/collections/create-subscription`, {
        userId: userUID, // ID del usuario autenticado
        planId: stripePrice//ID del plan en Stripe
      });

      // Paso 2: Redirige al usuario a la sesión de Stripe
      if (data.url) {
        window.location.href = data.url; // Redirige a la URL de la sesión
      } else {
        setErrorMessage('Error al crear la sesión de pago');
      }
    } catch (error) {
      setErrorMessage('Hubo un error al crear la sesión de pago. Intenta nuevamente.');
      console.error('Error al procesar la solicitud de sesión:', error);
    }

    setLoading(false);
  };

  return (
    <div>
      <h2>Realiza tu pago para obtener acceso Premium</h2>
      {paymentSuccess ? (
        <div>
          <h3>¡Pago completado con éxito!</h3>
          <p>Ahora tienes acceso a las funcionalidades Premium.</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <h3>Selecciona tu plan Premium</h3>
          {/* Aquí puedes añadir detalles sobre los planes */}
          <button type="submit" disabled={!stripe || loading}>
            {loading ? 'Procesando...' : 'Pagar con Stripe'}
          </button>
          {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}
        </form>
      )}
    </div>
  );
};

export default Payment;
